import { KIND_BADGE, KIND_LABEL, kindOf, WorkspaceKind } from "./kind";

// "Verkenning" of "Project", in de kleur van die soort.
export const KindBadge = ({
  workspace,
  className = "",
}: {
  workspace: { kind?: WorkspaceKind };
  className?: string;
}) => {
  const kind = kindOf(workspace);
  return (
    <span
      className={`inline-block shrink-0 rounded px-1.5 py-0.5 text-[11px] font-semibold ${KIND_BADGE[kind]} ${className}`}
    >
      {KIND_LABEL[kind]}
    </span>
  );
};
